import { InitAssistantData } from 'core_main/api/assistant/types';
import { InitAssistantCallbackResponse } from './types';

export const createInitAssistantCallbackResponse = (
  data: InitAssistantData,
): InitAssistantCallbackResponse => {
  return {
    assistant: data?.meta?.assistant,
    dialog: data?.meta?.dialog,
    node: data?.meta?.node,
    initialMessages: data?.initialMessages,
    attributes: data?.attributes,
  };
};
